import HeadingSecondary from "../components/ HeadingSecondary";
import External from "../components/svg/margrave/External";
import Internal from "../components/svg/margrave/Internal";
import Train from "../components/svg/margrave/Train";
import Bus from "../components/svg/margrave/Bus";
import LeftArrow from "../components/svg/setting/LeftArrow";
import Ship from "../components/svg/margrave/Ship";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PrivateCarPermission from "../components/svg/margrave/PrivateCarPermission";

const Margrave = () => {
  const notify = () => {
    toast.info("به زودی", {
      position: "top-center",
      autoClose: 1500,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      progress: undefined,
    });
  };
  return (
    <div className="margrave">
      <ToastContainer rtl />
      <div className="u-margin-top-small-3-5 u-margin-bottom-small-2">
        <HeadingSecondary text="مسافران" subText="(مرزبانی)" />
      </div>
      <div className="margrave__list u-margin-top-medium-5">
        <div className="margrave__list__row" onClick={notify}  >
          <div className="margrave__list__row__right" >
            <span className="margrave__list__row__right--icon"
                  style={{ width: "28px", height: "28px" }}
            >
               <PrivateCarPermission />
            </span>
            <span className="margrave__list__row__right--title"
            >
            مجوز تردد خودرو شخصی
            </span>
          </div>
          <div className="margrave__list__row__left">
            <span>
              <LeftArrow />
            </span>
          </div>
        </div>

        {/*<NavLink className="margrave__list__row" to={"/margrave/travel-permit"}>*/}
        {/*  <div className="margrave__list__row__right">*/}
        {/*    <span className="margrave__list__row__right--icon">*/}
        {/*      <Pilgrim />*/}
        {/*    </span>*/}
        {/*    <span className="margrave__list__row__right--title">*/}
        {/*   زائران اربعین*/}
        {/*    </span>*/}
        {/*  </div>*/}
        {/*  <div className="margrave__list__row__left">*/}
        {/*    <span>*/}
        {/*      <LeftArrow />*/}
        {/*    </span>*/}
        {/*  </div>*/}
        {/*</NavLink>*/}

        <div className="margrave__list__row" onClick={notify}>
          <div className="margrave__list__row__right">
            <span
              className="margrave__list__row__right--icon"
              style={{ width: "28px", height: "28px" }}
            >
              <External />
            </span>
            <span className="margrave__list__row__right--title">مسافران پروازهای خارجی </span>
          </div>
          <div className="margrave__list__row__left">
            <span>
              <LeftArrow />
            </span>
          </div>
        </div>

        <div className="margrave__list__row" onClick={notify}>
          <div className="margrave__list__row__right">
            <span
              className="margrave__list__row__right--icon"
              style={{ width: "23px", height: "28px" }}
            >
              <Internal />
            </span>
            <span className="margrave__list__row__right--title">مسافران پروازهای داخلی</span>
          </div>
          <div className="margrave__list__row__left">
            <span>
              <LeftArrow />
            </span>
          </div>
        </div>

        <div className="margrave__list__row" onClick={notify}>
          <div className="margrave__list__row__right">
            <span
              className="margrave__list__row__right--icon"
              style={{ width: "24px", height: "24px" }}
            >
              <Train />
            </span>
            <span className="margrave__list__row__right--title">مسافران قطار</span>
          </div>
          <div className="margrave__list__row__left">
            <span>
              <LeftArrow />
            </span>
          </div>
        </div>

        <div className="margrave__list__row" onClick={notify}>
          <div className="margrave__list__row__right">
            <span
              className="margrave__list__row__right--icon"
              style={{ width: "28px", height: "28px" }}
            >
              <Bus />
            </span>
            <span className="margrave__list__row__right--title">پایانه‌های جاده‌ای</span>
          </div>
          <div className="margrave__list__row__left">
            <span>
              <LeftArrow />
            </span>
          </div>
        </div>

        <div className="margrave__list__row" onClick={notify}>
          <div className="margrave__list__row__right">
            <span
              className="margrave__list__row__right--icon"
              style={{ width: "28px", height: "28px" }}
            >
              <Ship />
            </span>
            <span className="margrave__list__row__right--title">مسافران دریایی</span>
          </div>
          <div className="margrave__list__row__left">
            <span>
              <LeftArrow />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Margrave;
